import { onSnapshot } from 'firebase/firestore';
import { useMemo, useState, useEffect } from 'react';
import { getBidsByProductIdQuery, BidDocument } from '@util/firestore/bid';

const useRealTimeBids = (productId: string, uid?: string) => {
  const [realTimeBids, setBids] = useState<BidDocument[]>([]);
  const bidsQuery = useMemo(
    () => getBidsByProductIdQuery(productId),
    [productId]
  );

  const highestBid = useMemo(() => {
    return realTimeBids.sort((a, b) => b.bid_price - a.bid_price)[0];
  }, [realTimeBids]);

  const usersBids = useMemo(() => {
    return realTimeBids.filter((bid) => uid && bid.uid === uid);
  }, [realTimeBids, uid]);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      bidsQuery,
      (snapshot) => {
        const realTimeData = snapshot.docs.map((doc) => doc.data());
        setBids(realTimeData);
      },
      // Network-class errors (deadline-exceeded, unavailable) on mobile/flaky
      // connections used to bubble out of the listener and crash the React tree.
      (err) => {
        console.warn('[useRealtimeBids] snapshot error:', err);
      }
    );
    return () => {
      unsubscribe();
    };
  }, [bidsQuery]);

  return {
    highestBid,
    usersBids,
    realTimeBids,
  };
};

export default useRealTimeBids;
